import React, { Suspense, useContext, useEffect } from 'react';

import TopicFilters from 'components/TopicFilters/TopicFilters';
import PerformanceBreakdownLoader from 'components/data-containers/PerformanceBreakdown/SkeletonLoader';

import { useDispatch } from 'react-redux';
import { loadAgeGroups } from 'redux/reducers/ageGroups';
import { EntityContext } from 'context/entityContext';
import { audienceSubTopics } from 'topics';

import PerformanceTrendSkeletonLoader from 'components/data-containers/PerformanceTrend/SkeletonLoader';
import GenderBreakdownLoader from 'components/data-containers/Audience/GenderBreakdown/SkeletonLoader';
import AgeOverTimeLoader from 'components/data-containers/Audience/AgeOverTime/Loaders/SkeletonLoader';
import SubNavigation from 'components/SubNavigation/SubNavigation';

const AudiencePerformanceTrend = React.lazy(
  (): any =>
    import('components/data-containers/PerformanceTrend/AudienceTrendComponent')
);

const AgeBreakdown = React.lazy(
  () => import('components/data-containers/Audience/AgeBreakdown/AgeBreakdown')
);

const GenderBreakdown = React.lazy(
  () => import('components/data-containers/Audience/GenderBreakdown/index')
);

const AgeOverTimeBreakdown = React.lazy(
  () => import('components/data-containers/Audience/AgeOverTime/AgeOverTime')
);
const Audience: React.FC<any> = () => {
  const { compareMode, filters, topic } = useContext(EntityContext);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadAgeGroups(filters?.streaming));
  }, [dispatch, filters]);

  return (
    <div>
      <SubNavigation topic="audience" variants={audienceSubTopics} />
      <TopicFilters
        topic={topic[1] || (topic[0] as any)}
        compareMode={compareMode}
      />

      <Suspense
        fallback={
          <PerformanceTrendSkeletonLoader
            title="Audience"
            showPeriodDropdown
            dropdownLabel="View By Last 30 Days"
            isWide
          />
        }
      >
        <AudiencePerformanceTrend type={compareMode && 'Streams'} />
      </Suspense>

      {compareMode && (
        <>
          <Suspense
            fallback={
              <PerformanceTrendSkeletonLoader
                title="Audience"
                showPeriodDropdown
                dropdownLabel="View By Last 30 Days"
                isWide
              />
            }
          >
            <AudiencePerformanceTrend type={compareMode && 'Listeners'} />
          </Suspense>
        </>
      )}

      <Suspense
        fallback={
          <GenderBreakdownLoader
            isNarrowScreen
            keyValueCount={4}
            showPeriodDropdown
            title="Gender Breakdown"
          />
        }
      >
        <GenderBreakdown />
      </Suspense>
      <Suspense
        fallback={
          <PerformanceBreakdownLoader
            barCount={6}
            title={'Age Breakdown'}
            isWide
          />
        }
      >
        <AgeBreakdown />
      </Suspense>
      <Suspense
        fallback={
          <AgeOverTimeLoader
            isNarrowScreen
            showPeriodDropdown
            title="Age Over Time"
          />
        }
      >
        <AgeOverTimeBreakdown />
      </Suspense>
    </div>
  );
};

export default Audience;
